import classNames from "classnames";
import React, { ReactNode } from "react";

import "./ACSettingSectionCard.less";

interface ACSettingSectionCardProps {
  title?: ReactNode | ReactNode[];
  children: ReactNode | ReactNode[];
  contentPadding?: boolean;
}

export default function ACSettingSectionCard({
  title,
  children,
  contentPadding = true,
}: ACSettingSectionCardProps) {
  return (
    <div className="ac-setting-section-card">
      {title && <div className="ac-setting-section-card-title">{title}</div>}
      <div
        className={classNames("ac-setting-section-card-content", {
          padding: contentPadding,
        })}
      >
        {children}
      </div>
    </div>
  );
}
